.map { width: 100%; height: 100%; }
.map :global(.maplibregl-ctrl-attrib) { font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.8px; background: color-mix(in srgb, var(--paper) 80%, transparent); }

